import axios from 'axios';

import { getConfigProperty } from '../../../core/EnvironmentConfig/EnvironmentConfig';
// Types
import {
    BANK_DETAILS_REQUEST_START,
    BANK_DETAILS_REQUEST_FAIL,
    BANK_DETAILS_REQUEST_SUCCESS,
    RETRIEVE_BANK_DETAILS_REQUEST_START,
    RETRIEVE_BANK_DETAILS_REQUEST_FAIL,
    RETRIEVE_BANK_DETAILS_REQUEST_SUCCESS,
    RESET_RETRIEVE_BANK_DETAILS,
    CREATE_BANK_DETAILS_REQUEST_START,
    CREATE_BANK_DETAILS_REQUEST_FAIL,
    CREATE_BANK_DETAILS_REQUEST_SUCCESS,
    GET_ALL_COUNTRY_DETAILS_REQUEST_START,
    GET_ALL_COUNTRY_DETAILS_REQUEST_FAIL,
    GET_ALL_COUNTRY_DETAILS_REQUEST_SUCCESS,
    GET_ALL_CURRENCY_DETAILS_REQUEST_FAIL,
    GET_ALL_CURRENCY_DETAILS_REQUEST_START,
    GET_ALL_CURRENCY_DETAILS_REQUEST_SUCCESS,
    BANK_DETAILS_V2_REQUEST_START,
    BANK_DETAILS_V2_REQUEST_FAIL,
    BANK_DETAILS_V2_REQUEST_SUCCESS,
    DELETE_BANK_DETAILS_REQUEST_START,
    DELETE_BANK_DETAILS_REQUEST_FAIL,
    DELETE_BANK_DETAILS_REQUEST_SUCCESS,
    RESET_CREATE_BANK_DETAILS,
    RESET_DELETE_BANK_DETAILS,
    RESET_ADD_BANK_DOCUMENT_DETAILS,
    ADD_BANK_DETAILS_DOCUMENT_REQUEST_START,
    ADD_BANK_DETAILS_DOCUMENT_REQUEST_FAIL,
    ADD_BANK_DETAILS_DOCUMENT_REQUEST_SUCCESS,
    FETCH_ORGANIZATION_BANK_DETAILS_REQUEST_START,
    FETCH_ORGANIZATION_BANK_DETAILS_REQUEST_FAIL,
    FETCH_ORGANIZATION_BANK_DETAILS_REQUEST_SUCCESS
} from './types';
// Redux
import { get, post, request } from './../session/actions';
import { getServicesErrorObj } from '../servicesDowntime/actions';
// Utils
import { getReferringCompany } from '../../../core/utils/ReferringCompanyValueGetter/ReferringCompanyValueGetter';
// Constants
import {
    CDSA_REFERRING_VALUE,
    ORGANIZATION__CODE_MAPPING,
    BANK_LOCAL_CODE_TYPE_COUNTRY_MAPPING,
    BANK_LOCAL_CODE_TYPE_COUNTRY_DEFAULT_CODE
} from '../../../core/utils/Constants/Constants';

export const getBankDetailsRequestStart = () => ({
    type: BANK_DETAILS_REQUEST_START
});

export const getBankDetailsRequestFail = () => ({
    type: BANK_DETAILS_REQUEST_FAIL
});

export const getBankDetailsRequestSuccess = (payload: any) => ({
    type: BANK_DETAILS_REQUEST_SUCCESS,
    payload
});

export const retrieveBankDetailsRequestStart = () => ({
    type: RETRIEVE_BANK_DETAILS_REQUEST_START
});

export const retrieveBankDetailsRequestFail = () => ({
    type: RETRIEVE_BANK_DETAILS_REQUEST_FAIL
});

export const retrieveBankDetailsRequestSuccess = (payload: any) => ({
    type: RETRIEVE_BANK_DETAILS_REQUEST_SUCCESS,
    payload
});

export const createBankDetailsRequestStart = () => ({
    type: CREATE_BANK_DETAILS_REQUEST_START
});

export const createBankDetailsRequestFail = () => ({
    type: CREATE_BANK_DETAILS_REQUEST_FAIL
});

export const createBankDetailsRequestSuccess = (payload: any) => ({
    type: CREATE_BANK_DETAILS_REQUEST_SUCCESS,
    payload
});

export const resetCreateBankDetailsObject = () => ({
    type: RESET_CREATE_BANK_DETAILS
});

export const resetRetrieveBankDetailsObject = () => ({
    type: RESET_RETRIEVE_BANK_DETAILS
});


export const getAllCountryDataRequestStart = () => ({
    type: GET_ALL_COUNTRY_DETAILS_REQUEST_START
});

export const getAllCountryDataRequestFail = () => ({
    type: GET_ALL_COUNTRY_DETAILS_REQUEST_FAIL
});

export const getAllCountryDataRequestSuccess = (payload: any) => ({
    type: GET_ALL_COUNTRY_DETAILS_REQUEST_SUCCESS,
    payload
});

export const getAllCurrencyDataRequestStart = () => ({
    type: GET_ALL_CURRENCY_DETAILS_REQUEST_START
});

export const getAllCurrencyDataRequestFail = () => ({
    type: GET_ALL_CURRENCY_DETAILS_REQUEST_FAIL
});

export const getAllCurrencyDataRequestSuccess = (payload: any) => ({
    type: GET_ALL_CURRENCY_DETAILS_REQUEST_SUCCESS,
    payload
});


export const getBankDetailsV2RequestStart = () => ({
    type: BANK_DETAILS_V2_REQUEST_START
});

export const getBankDetailsV2RequestFail = () => ({
    type: BANK_DETAILS_V2_REQUEST_FAIL
});

export const getBankDetailsV2RequestSuccess = (payload: any) => ({
    type: BANK_DETAILS_V2_REQUEST_SUCCESS,
    payload
});

export const deleteBankDetailsRequestStart = () => ({
    type: DELETE_BANK_DETAILS_REQUEST_START
});

export const deleteBankDetailsRequestFail = () => ({
    type: DELETE_BANK_DETAILS_REQUEST_FAIL
});

export const deleteBankDetailsRequestSuccess = (payload: any) => ({
    type: DELETE_BANK_DETAILS_REQUEST_SUCCESS,
    payload
});

export const resetDeleteBankDetailsObject = () => ({
    type: RESET_DELETE_BANK_DETAILS
});

export const addBankDetailsDocumentRequestStart = () => ({
    type: ADD_BANK_DETAILS_DOCUMENT_REQUEST_START
});

export const addBankDetailsDocumentRequestFail = () => ({
    type: ADD_BANK_DETAILS_DOCUMENT_REQUEST_FAIL
});

export const addBankDetailsDocumentRequestSuccess = (payload: any) => ({
    type: ADD_BANK_DETAILS_DOCUMENT_REQUEST_SUCCESS,
    payload
});

export const resetAddBankDetailsDocumentObject = () => ({
    type: RESET_ADD_BANK_DOCUMENT_DETAILS
});

export const fetchOrganizationBankDetailsRequestStart = () => ({
    type: FETCH_ORGANIZATION_BANK_DETAILS_REQUEST_START
});

export const fetchOrganizationBankDetailsRequestFail = () => ({
    type: FETCH_ORGANIZATION_BANK_DETAILS_REQUEST_FAIL
});

export const fetchOrganizationBankDetailsRequestSuccess = (payload: any) => ({
    type: FETCH_ORGANIZATION_BANK_DETAILS_REQUEST_SUCCESS,
    payload
});

export const BANK_DETAILS_URL: Function = (customerProfileId: string) => (
    `/v1/affiliate-portal/affiliates/bankdetails?profileID=${customerProfileId}`
);

export const RETRIEVE_BANK_DETAILS_URL: Function = () => (
    `/v1/affiliate-portal/references/get-bankdetails`
);

export const COUNTRY_DETAILS_URL: string = `/affiliate-engine/Country/getAll`;

export const CURRENCY_DETAILS_URL: string = `/affiliate-engine/Currency/getAll`;

export const CREATE_BANK_DETAILS_URL = `/affiliate-engine/AffiliateDetails/create`;

export const BANK_DETAILS_V2_URL: Function = (affiliateNumber: string) => (
    `/affiliate-engine/AffiliateDetails/getAll?affiliateNumber=${affiliateNumber}`
);

export const DELETE_BANK_DETAILS: string = '/affiliate-engine/AffiliateDetails/update';

export const UPLOAD_BANK_DOCUMENT_DETAILS: string = getConfigProperty('apiEndPoint')['bankDocUpload'];

export const FETCH_ORGANIZATION_BANK_DETAILS_URL = '/v1/affiliate-portal/bank/fetchOrganizationBankDetails';

export const getBankDetails = (profileId: string) => (
    dispatch: Function
) => new Promise((resolve, reject) => {
    dispatch(getBankDetailsRequestStart());
    dispatch(get(BANK_DETAILS_URL(profileId))).then((response) => {
        dispatch(getBankDetailsRequestSuccess(response.data));
    }).catch((error) => {
        dispatch(getBankDetailsRequestFail());
        dispatch(getServicesErrorObj(error));
        reject(error);
    })
});

export type BankDetailsAction = {
    type: string,
    payload?: any
}

export const retrieveBankDetails = (selectedFields) => (
    dispatch: Function
) => new Promise((resolve, reject) => {
    dispatch(retrieveBankDetailsRequestStart());
    dispatch(post(RETRIEVE_BANK_DETAILS_URL(), selectedFields))
        .then((response) => {
            dispatch(retrieveBankDetailsRequestSuccess(response.data));
            resolve(response);
        }).catch((error) => {
            dispatch(retrieveBankDetailsRequestFail());
            dispatch(getServicesErrorObj(error));
            reject(error);
        })
});

export const resetRetrieveBankDetails = () => (
    dispatch: Function
) => new Promise((resolve, reject) => {
    dispatch(resetRetrieveBankDetailsObject());
});

const getHeaderPacket = () => {
    const referringCompany = getReferringCompany();
    const organization: string = ORGANIZATION__CODE_MAPPING[referringCompany];

    return {
        'X-Organization': referringCompany === CDSA_REFERRING_VALUE ? "CD SA" : organization,
        'X-Timestamp': new Date().toISOString(),
        'X-Username': 'affiliate portal'
    };
};

export const createBankDetails = (formFields, affiliateDetails, selectedCountryDetail, selectedCurrencyDetail, bankDetailsDocUploadResponse) => (
    dispatch: Function
) => new Promise((resolve, reject) => {
    const { accountNumber, sortCode, bsbNumber, transitNumber, abaNumber, branchCode, ifscCode, iban, cnapsCode, swiftCode,
        accountName, country, currency, affiliateBank, branchAddress } = formFields || {};
    const { affiliateProfileId, affiliate: { affiliate_Number, user_last_name, user_first_name } } = affiliateDetails || {};
    const { id: countryid, countryName } = selectedCountryDetail || {};
    const { id: currencyid } = selectedCurrencyDetail || {};
    const { document_id } = bankDetailsDocUploadResponse || {};

    const packet = {
        "accountName": accountName,
        "accountNumber": accountNumber || iban,
        "affiliateBank": affiliateBank,
        "accountStatus": "ACTIVE",
        "countryId": countryid,
        "currencyId": currencyid,
        "beneficiaryAddress": "",
        "beneficiaryCity": "",
        "beneficiaryPostalCode": "",
        "branchPhoneNumber": "",
        "beneficiaryEmail": "",
        "branchName": affiliateBank,
        "branchAddress": branchAddress,
        "swiftCode": swiftCode,
        "localCode": sortCode || bsbNumber || transitNumber || abaNumber || branchCode || ifscCode || cnapsCode,
        "viaBank": false,
        "viaAffiliateBank": "",
        "viaBranchName": "",
        "viaBranchAddress": "",
        "viaSwiftCode": "",
        "viaLocalCode": "",
        "ffcDetail": "",
        "charges": "SHA",
        "settlement": "",
        "fundsOutMethod": "HEXAGON",
        "affiliateAccountId": affiliateProfileId,
        "affiliateNumber": affiliate_Number,
        "accountType": "b",
        "updatedDate": new Date().toISOString(),
        "updatedBy": `${user_first_name} ${user_last_name}`,
        "affiliateBankId": null,
        "country": countryName,
        "currency": currency,
        "viaCountryId": null,
        "localCodeType": BANK_LOCAL_CODE_TYPE_COUNTRY_MAPPING.hasOwnProperty(country) ? BANK_LOCAL_CODE_TYPE_COUNTRY_MAPPING[country] : BANK_LOCAL_CODE_TYPE_COUNTRY_DEFAULT_CODE,
        "viaLocalCodeType": "BRANCH",
        "createdDate": new Date().toISOString(),
        "createdBy": `${user_first_name} ${user_last_name}`,
        ...(document_id && { "documentId": document_id })
    };
    dispatch(createBankDetailsRequestStart());
    dispatch(request({
        url: CREATE_BANK_DETAILS_URL,
        method: "POST",
        headers: getHeaderPacket(),
        data: {
            ...packet
        }
    })
    ).then((response) => {
        dispatch(createBankDetailsRequestSuccess(response.data));
        dispatch(resetAddBankDetailsDocumentObject());
        resolve(response);
    }).catch((error) => {
        dispatch(createBankDetailsRequestFail());
        dispatch(getServicesErrorObj(error));
        reject(error);
    })
});

export const resetCreateBankDetails = () => (
    dispatch: Function
) => new Promise((resolve, reject) => {
    dispatch(resetCreateBankDetailsObject());
});

export const getCountryDetails = () => (
    dispatch: Function
) => new Promise((resolve, reject) => {
    dispatch(getAllCountryDataRequestStart());
    dispatch(request({
        url: COUNTRY_DETAILS_URL,
        method: "GET",
        headers: getHeaderPacket()
    })
    ).then((response) => {
        dispatch(getAllCountryDataRequestSuccess(response.data));
        resolve(response.data);
    }).catch((error) => {
        dispatch(getAllCountryDataRequestFail());
        dispatch(getServicesErrorObj(error));
        reject(error);
    })
});

export const getCurrencyDetails = () => (
    dispatch: Function
) => new Promise((resolve, reject) => {
    dispatch(getAllCurrencyDataRequestStart());
    dispatch(request({
        url: CURRENCY_DETAILS_URL,
        method: "GET",
        headers: getHeaderPacket()
    })
    ).then((response) => {
        dispatch(getAllCurrencyDataRequestSuccess(response.data));
        resolve(response.data);
    }).catch((error) => {
        dispatch(getAllCurrencyDataRequestFail());
        dispatch(getServicesErrorObj(error));
        reject(error);
    })
});

export const getBankDetailsV2 = (affiliateNumber: string) => (
    dispatch: Function
) => new Promise((resolve, reject) => {
    dispatch(getBankDetailsV2RequestStart());

    dispatch(request({
        url: BANK_DETAILS_V2_URL(affiliateNumber),
        method: "GET",
        headers: getHeaderPacket()
    }))
        .then((response) => {
            dispatch(getBankDetailsV2RequestSuccess(response.data));
        }).catch((error) => {
            dispatch(getBankDetailsV2RequestFail());
            dispatch(getServicesErrorObj(error));
            reject(error);
        })
});



export const deleteBankDetails = (payload: any) => (
    dispatch: Function
) => new Promise((resolve, reject) => {
    dispatch(deleteBankDetailsRequestStart());

    dispatch(request({
        url: DELETE_BANK_DETAILS,
        method: "PUT",
        headers: getHeaderPacket(),
        data: {
            ...payload
        }
    }))
        .then((response) => {
            dispatch(deleteBankDetailsRequestSuccess(response.data));
        }).catch((error) => {
            dispatch(deleteBankDetailsRequestFail());
            dispatch(getServicesErrorObj(error));
            reject(error);
        })
});

export const resetDeleteBankDetails = () => (
    dispatch: Function
) => new Promise((resolve, reject) => {
    dispatch(resetDeleteBankDetailsObject());
});



export const uploadBankDetailsDocument = (payload: any) => (
    dispatch: Function
) => new Promise((resolve, reject) => {
    dispatch(addBankDetailsDocumentRequestStart());

    axios.post(UPLOAD_BANK_DOCUMENT_DETAILS, payload, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            'Content-Type': 'application/json'
        }
    })
        .then((response) => {
            dispatch(addBankDetailsDocumentRequestSuccess(response.data));
        }).catch((error) => {
            dispatch(addBankDetailsDocumentRequestFail());
            dispatch(getServicesErrorObj(error));
            reject(error);
        })
});

export const resetUploadBankDetails = () => (
    dispatch: Function
) => new Promise((resolve, reject) => {
    dispatch(resetAddBankDetailsDocumentObject());
});

export const fetchOrganizationBankDetails = (payload: { currency: string, affiliateLegalEntity: string, countryIsoCode: string }) => (
    dispatch: Function
) => new Promise((resolve, reject) => {
    dispatch(fetchOrganizationBankDetailsRequestStart());

    dispatch(request({
        url: FETCH_ORGANIZATION_BANK_DETAILS_URL,
        method: "POST",
        headers: getHeaderPacket(),
        data: payload
    }))
        .then((response) => {
            const hasData = response.data && response.data.message !== "Legal Entity's Banks Details Not Found" && Object.values(response.data).some(value => value !== null && value !== '');
            if (hasData) {
                dispatch(fetchOrganizationBankDetailsRequestSuccess(response.data));
                resolve(response.data);
            } else {
                dispatch(fetchOrganizationBankDetailsRequestFail());
                reject('No bank details found');
            }
        }).catch((error) => {
            dispatch(fetchOrganizationBankDetailsRequestFail());
            dispatch(getServicesErrorObj(error));
            reject(error);
        })
});